import React from 'react';
import Section from "./components/Section";
import {lightGradient} from "./Helpers";
import {MD_BREAKPOINT} from "../../../Constants/Constants";
import Media from "react-media";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import WorkIcon from '@material-ui/icons/Work';
import StarIcon from '@material-ui/icons/Star';
import { Green20 as colorScheme } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau';

class Internships extends Section {

	constructor(props) {
		super(props);
		//console.log("About Constructor", props);
		this.aboutRef = React.createRef();
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.aboutRef);
	}

	styles = {
		...Section.styles,
		mainContainer: {
			...Section.styles.mainContainer,
			// background: "url(" + IMAGES_DIR + "/home.jpg)",
			// backgroundSize: "cover",
			backgroundImage: (this.props.backgroundColor ? lightGradient(this.props.backgroundColor) : "#fff"),
			backgroundAttachment: 'fixed',
		},
		contentContainer: {
			...Section.styles.contentContainer,
			padding: "auto",
			// minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			// alignContent: "center",
			justifyContent: "center",
			// alignItems: "center",
			// fontSize: "4.5vmin"
		},
		title: {
			...Section.styles.title,
			fontStyle: "bold",
			textAlign: "center"
		},
		subTitle: {
			...Section.styles.subTitle,
			maxWidth: "90%",
		},
	};

	render() {
		return (
			<div style={this.styles.mainContainer} ref={this.aboutRef}>
				<div style={this.styles.contentContainer}>
					<h1 style={this.styles.title}>{this.props.title}</h1>
					{this.props.subtitle ? <h2 style={this.styles.subTitle}>{this.props.subtitle}</h2> : null}
					{/*<Carousel items={this.props.data}/>*/}
					<VerticalTimeline className="vertical-timeline">
						{
							this.props.data.map((item, index) => {
								return (
									<CommonListItem key={index} styles={this.styles} {...item} renderDate={true} index={index}/>
								)
							})
						}
						<VerticalTimelineElement
							iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
							icon={<StarIcon />}
						/>
					</VerticalTimeline>
				</div>
			</div>
		);
	}
}

export const CommonListItem = (props) => {
	//console.log(props);	
	const title = (
		<div key="title" style={{
				...props.styles.subTitle, 
				marginBottom: '0.5rem',
				fontSize: '3vmin',
				lineHeight: '4vmin',
			}}
		>
			{props.title}
		</div>
	);
	const durationString = props.startDate ? props.startDate + " - " + props.endDate : props.endDate;
	const duration = null;
	// props.startDate ? 
	// 	(<div style={{marginBottom: '0.5rem'}} key="duration">{props.startDate + " - " + props.endDate}</div>)
	// 	:
	// 	(<div style={{marginBottom: '0.5rem'}} key="duration">{props.endDate}</div>);
	const subtitle = (
		<div 
			key="subtitle" 
			style={{
				fontStyle: 'italic', 
				marginBottom: '0rem',
				fontSize: '2.5vmin',
				lineHeight: '3vmin',
			}}
		>
			{props.subTitle}
		</div>
	);
	const description = props.description && (
		<ul key="description" style={{textAlign: "justify", marginTop: "1rem"}}>
			{
				props.description.map((item, index)=> (
					<li style={{				
						fontSize: '2vmin',
						lineHeight: '3vmin',
					}} 
					key={index}>{item}</li>)
				)
			}
		</ul>
	);

	return (
		<VerticalTimelineElement
			// contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
			// contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
			date={durationString}
			iconStyle={{ background: colorScheme[colorScheme.length-1-props.index], color: '#fff' }}
			icon={<WorkIcon />}
		>
			<Media query={`(max-width: ${MD_BREAKPOINT}px)`}>
				{
					matches => matches ?
						(
							<div style={{
									...props.styles.contentContainer, 
									// paddingBottom: "2vmin"
								}}>
								<div style={{display: 'flex', flexDirection: "column"}}>
									{[title, duration, subtitle]}
								</div>
							</div>
						)
						:
						(							
							<div style={{
									...props.styles.contentContainer, 
									// paddingBottom: "2vmin"
								}}>
								<div style={{display: 'flex', flexDirection: "column"}}>
									<div style={{display: 'flex', flexDirection: "row", justifyContent: "space-between"}}>
										{[title, duration]}
									</div>
									{[subtitle, description]}
								</div>
							</div>
						)
				}
			</Media>
		</VerticalTimelineElement>
	);
};

export default Internships;